
  import { defineComponent, ref, Ref, watchEffect } from "vue";
  import { useStore } from "vuex";
  import { CarItem } from './../../Store/form/types';
  import { FormGetters } from './../../Store/index';

  import SelectComponent from "./../Form/SelectComponent.vue";
  import InputComponent from "./../Form/InputComponent.vue";

  import { getCarsBelowThreshold } from "./../../Composables/form";

  export default defineComponent({
    name: "MotorcycleComponent",

    computed: {
      FormGetters() {
        return FormGetters
      }
    },

    components: {
      InputComponent,
      SelectComponent
    },

    props: {},

    setup() {
      // Get the Vuex store instance
      const store = useStore();

      // Get various data from the store using getters
      const labels = store.getters[`form/${FormGetters.GET_LABELS}`];

      let carsBelowThreshold: Ref<CarItem[]> = ref([]);

      // Watch for changes in car count
      watchEffect(() => {
        carsBelowThreshold.value = getCarsBelowThreshold(store);
      })

      // Return the data
      return {
        store,
        labels,
        carsBelowThreshold
      }
    }
  })
